'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _typeof = require('@babel/runtime/helpers/typeof');
var colors = require('../theme/foundations/colors.js');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
exports.LogType = void 0;

/**
 * Logs info, warning or error messages to the console via `console` functions.
 * Note: Only logs in development.
 */
(function (LogType) {
  LogType["warning"] = "warning";
  LogType["error"] = "error";
  LogType["info"] = "info";
})(exports.LogType || (exports.LogType = {}));
var logger = function logger(type, message, component, condition) {
  // Don't do anything in production.
  // This is wrapped in a production check for better dead code elimination.
  if (utils.__DEV__) {
    // If a condition exists and it is false, return.
    if (_typeof__default["default"](condition) !== undefined && condition === false) {
      return;
    }

    // If console does not exist, return.
    if (typeof console === 'undefined') {
      return;
    }
    var componentString = "".concat(typeof component === 'string' ? "[".concat(component, "] ") : "");

    // Construct the message
    var messageWithColor = "%c@hausgold/designsystem%c %c".concat(type.charAt(0).toUpperCase() + type.slice(1), "%c: ").concat(componentString).concat(message);
    var messageWithoutColor = "@hausgold/designsystem ".concat(type.charAt(0).toUpperCase() + type.slice(1), ": ").concat(componentString).concat(message);
    switch (type) {
      case exports.LogType.error:
        // eslint-disable-next-line no-console
        console.error(messageWithColor, "color: ".concat(colors["default"].blue['400']), "color: ".concat(colors["default"].red['900']), "color: inherit", "color: inherit");

        // Throw an error and catch it immediately to improve debugging
        //
        // A consumer can use "pause on caught exceptions", see:
        // https://github.com/facebook/react/issues/4216
        try {
          throw Error(messageWithoutColor);
          // eslint-disable-next-line no-empty
        } catch (x) {}
        break;
      case exports.LogType.info:
        // eslint-disable-next-line no-console
        console.info(messageWithColor, "color: ".concat(colors["default"].blue['400']), "color: ".concat(colors["default"].gray['200']), "color: inherit", "color: inherit");
        break;
      case exports.LogType.warning:
        // eslint-disable-next-line no-console
        console.warn(messageWithColor, "color: ".concat(colors["default"].blue['400']), "color: ".concat(colors["default"].yellow['400']), "color: inherit", "color: inherit");
        break;
    }
  }
};

/**
 * Shorthand warning function for `logger`
 */
var warn = function warn(message, component, condition) {
  return logger(exports.LogType.warning, message, component, condition);
};

/**
 * Shorthand error function for `logger`
 */
var error = function error(message, component, condition) {
  return logger(exports.LogType.error, message, component, condition);
};
exports["default"] = logger;
exports.error = error;
exports.warn = warn;